import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconTrophy = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M6 9H4.5a2.5 2.5 0 0 1 0-5H6' />
      <path d='M18 9h1.5a2.5 2.5 0 0 0 0-5H18' />
      <path d='M4 22h16' />
      <path d='M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22' />
      <path d='M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22' />
      <path d='M18 2H6v7a6 6 0 0 0 12 0V2Z' />
    </g>
  </SDIcon>
)

export default IconTrophy
